<kendo-dialog-titlebar (close)="fecheModal(this.insumo)"  >
  <h4 class="modal-title">
    <img src="assets/fidelidade/icones/adicionar-insumo.png" style="height: 32px;"/>
    <ng-container *ngIf="insumo.id"> {{insumo.fichaTecnica ?  'Ficha Técnica': 'Insumo' }} {{insumo.id}} - {{insumo.nome}}</ng-container>
    <ng-container *ngIf="!insumo.id">  {{insumo.fichaTecnica ? 'Nova Ficha Técnica' : 'Novo Insumo'}} </ng-container>
  </h4>
</kendo-dialog-titlebar>

<div   class="modal-body">

  <kendo-tabstrip class="nav-bordered"   #tabSet       >
    <kendo-tabstrip-tab [title]="'Detalhes'" [selected]="abaSelecionada === 1">
      <ng-template kendoTabContent>
        <div *ngIf="!insumo.tipo && insumo.fichaTecnica">
          <h4 class="text-center">Qual será o tipo da ficha tecnica? </h4>

          <div class="button-row mt-3">
            <div class="button-column">
              <button kendoButton look="outline" class="btn-verde" icon="cart" (click)="escolheuTipo(this.FICHA_PRODUTO_VENDA)">
                Produto para Venda
              </button>


              <div class="button-description">
                 Use para produtos preparados conforme a venda, sem manter estoque do produto pronto.
                A venda desconta os ingredientes conforme a receita. Se faltar estoque de algum ingrediente, a venda será bloqueada.
                <br><em>Exemplos:</em> &nbsp;<b>Pizza, suco preparado na hora e salada.</b>
              </div>

            </div>
            <div class="button-column">
              <button kendoButton look="outline" class="btn-laranja"   (click)="escolheuTipo(this.FICHA_PRODUTO_BENEFICIADO)">
                <i class="fas fa-utensils"></i> Produto ou ingrediente beneficiado
              </button>
              <div class="button-description">
                  Use para itens produzidos antecipadamente e armazenados no estoque.
                A produção consome os ingredientes; a venda desconta apenas o item pronto.
                Só será possível vender a quantidade disponível no estoque.
                Pode ser vinculado diretamente a um produto do cardápio ou usado em outras receitas.
                <br><em>Exemplos:</em> &nbsp;<b>Bolo pronto, molho caseiro e frango desfiado.</b>
              </div>
            </div>

          </div>
        </div>

        <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
              novalidate #frm="ngForm" (ngSubmit)="onSalvar()" *ngIf="insumo.tipo || !insumo.fichaTecnica"  >

          <div class=" mt-2 mb-2 destaque" [hidden]="!insumo.fichaTecnica">
            <b>Ficha Técnica do</b>
            <label class="text-blue ml-1"><b>{{this.fichaTecnicaDeProdutoVenda() ? 'produto para venda' : 'produto ou ingrediente beneficiado'}}</b>
            </label>
          </div>

          <div class="row mb-2">
            <div class="form-group col-6"  >
              <label for="nome">Nome</label>
              <input type="text" class="form-control" autocomplete="off"
                     id="nome" name="nome" [(ngModel)]="insumo.nome" #nome="ngModel"
                     placeholder="Informe um nome" value="" required appAutoFocus [autoFocus]="true">
              <div class="invalid-feedback">
                <p *ngIf="nome.errors?.required">Nome é obrigatório</p>
              </div>
            </div>

            <div class="form-group  col-3">
              <label  >Código Sistema</label>

              <input type="text" class="form-control" autocomplete="off"
                     name="codigoPdv" [(ngModel)]="insumo.codigo" #codigo="ngModel"
                     placeholder="Cod. Sistema"       />
            </div>

          </div>

          <div class="row mb-2" >
            <div class="form-group  col-4">
              <label  >Unidade</label>

              <kendo-dropdownlist   name="unidade" [(ngModel)]="insumo.unidadeMedida" [data]="unidades"
                                    (ngModelChange)="alterouValorUnidade()"
                                    class="form-control"  [textField]="'nome'" required  #unidade="ngModel"

                                    style="border: none;">
              </kendo-dropdownlist>

              <div class="invalid-feedback">
                <p *ngIf="unidade.errors?.required">Unidade é obrigatório</p>
              </div>
            </div>

            <div class="form-group  col-4 ">
              <label >Grupo
                <button type="button" class="btn btn-xs btn-outline-blue   ml-1" (click)="abraModalNovoGrupo()" style="    position: absolute;top: -5px;">
                  <i class="k-icon k-i-plus "></i> adicionar grupo</button>
              </label>

              <kendo-dropdownlist  name="grupo" [(ngModel)]="insumo.grupo" [data]="grupos" [filterable]="true" required
                                   placeholder="Selecione um grupo" class="form-control" [textField]="'nome'"  #grupo="ngModel"
                                   style="border: none;"  (filterChange)="handleFilter($event)">
              </kendo-dropdownlist>

              <div class="invalid-feedback">
                <p *ngIf="grupo.errors?.required">Grupo é obrigatório</p>
              </div>

            </div>

          </div>

          <fieldset *ngIf=" !fichaTecnicaDeProdutoVenda()">
            <legend>Controle de estoque</legend>

            <div class="row">
              <div class="form-group  col-4">
                <label>{{controleCustoEstoqueAtivo && !insumo.id ? 'Quantidade inicial' : 'Estoque atual'}}</label>
                <kendo-numerictextbox id="estoque" [min]="0"   [format]="obtenhaFormato()"  [disabled]="insumo.id"
                                      class="form-control" name="quantidade" #quantidade=ngModel
                                      (valueChange)="alterouQuantidadeInicial($event)"
                                      [(ngModel)]="insumo.estoque.quantidade" required placeholder="Estoque atual">
                </kendo-numerictextbox>

                <div class="invalid-feedback">
                  <p *ngIf="quantidade.errors?.required">Estoque atual é obrigatório</p>
                </div>
              </div>

              <div class="form-group  col-4">
                <label  >Estoque minimo</label>
                <kendo-numerictextbox id="quantidadeMinima"    [format]="obtenhaFormato()"
                                      class="form-control" name="quantidadeMinima" #quantidadeMinima=ngModel

                                      [(ngModel)]="insumo.estoque.quantidadeMinima" required placeholder="Estoque minimo">
                </kendo-numerictextbox>

                <div class="invalid-feedback">

                </div>
              </div>

              <div class="form-group  col-4" *ngIf="insumo.id">
                <label  >Estoque reservado</label>
                <kendo-numerictextbox [min]="0"   [format]="obtenhaFormato()"  [disabled]="insumo.id"
                                      class="form-control" name="quantidadeReservada" #quantidadeReservada=ngModel

                                      [(ngModel)]="insumo.estoque.quantidadeReservada"    >
                </kendo-numerictextbox>

              </div>

             <!-- <div class="form-group  col-4">
                <label  >Preço custo</label>
                <kendo-numerictextbox id="precoDeCusto" [min]="0"   [format]="'c3'"
                                      class="form-control" name="precoDeCusto" #precoDeCusto=ngModel

                                      [(ngModel)]="insumo.precoDeCusto" required placeholder="Preço de custo">
                </kendo-numerictextbox>

                <div class="invalid-feedback">

                </div>
              </div> -->



            </div>

            <div class="row" *ngIf="controleCustoEstoqueAtivo && insumo.id">
              <div class="form-group col-4 mb-0">
                <label>Custo médio</label>
                <div class="form-control bg-light">
                  <strong *ngIf="insumo.estoque?.custoMedio != null">
                    {{insumo.estoque.custoMedio | currency:'BRL':'symbol':'1.2-6'}}
                  </strong>
                  <span class="text-muted" *ngIf="insumo.estoque?.custoMedio == null">
                    Ainda não calculado
                  </span>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="controleCustoEstoqueAtivo && !insumo.id">
              <div class="form-group col-6">
                <label>Custo unitário inicial</label>
                <kendo-numerictextbox [min]="0" [decimals]="6" [format]="'n6'"
                                      class="form-control" name="custoUnitarioInicial"
                                      [(ngModel)]="insumo.estoque.custoUnitarioInicial"
                                      (valueChange)="alterouCustoUnitarioInicial($event)"
                                      [required]="quantidadeInicialPositiva()"
                                      [disabled]="!quantidadeInicialPositiva()">
                </kendo-numerictextbox>
              </div>
              <div class="form-group col-6">
                <label>Valor total inicial</label>
                <kendo-numerictextbox [min]="0" [decimals]="6" [format]="'n6'"
                                      class="form-control" name="custoTotalInicial"
                                      [(ngModel)]="insumo.estoque.custoTotalInicial"
                                      (valueChange)="alterouCustoTotalInicial($event)"
                                      [required]="quantidadeInicialPositiva()"
                                      [disabled]="!quantidadeInicialPositiva()">
                </kendo-numerictextbox>
              </div>
            </div>
          </fieldset>

          <div class="modal-footer">
            <p *ngIf="mensagemSucesso" class="text-success ">
              <i class="mdi mdi-check-all mr-1"></i> {{mensagemSucesso}}
            </p>

            <p  *ngIf="mensagemErro" class="text-danger ">
              <i class="mdi mdi-check-all mr-1"></i> {{mensagemErro}}
            </p>

            <button type="submit" class="btn btn-primary waves-effect waves-light"
                    [disabled]="!frm.dirty || salvando || carregandoStatusControleCusto"
                    [hidden]="!insumo.id && insumo.fichaTecnica" >
              <i *ngIf="salvando" class="k-icon k-i-loading"></i>Salvar</button>

            <button type="button" class="btn btn-blue waves-effect waves-light" (click)="selecioneAba(2)"
                    [disabled]="salvando || carregandoStatusControleCusto || !frm.valid"
                    *ngIf="!insumo.id && insumo.fichaTecnica">
              <i *ngIf="salvando" class="k-icon k-i-loading"></i>Proximo</button>


            <button type="button" class="btn btn-light waves-effect" data-dismiss="modal"
                    (click)="fecheModal(this.insumo)">Fechar</button>
          </div>

        </form>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [title]="'Unidades de compra'" *ngIf="deveExibirApresentacoes()"
                        [selected]="abaSelecionada === 5">
      <ng-template kendoTabContent>
        <div class="apresentacoes-compra aba-unidades-compra p-3">
          <div class="apresentacoes-compra-cabecalho mb-2">
            <p class="text-muted mb-0">
              Unidade-base do estoque:
              <b>{{insumo.unidadeMedida?.nome}} ({{insumo.unidadeMedida?.sigla}})</b>
            </p>
            <span class="apresentacoes-compra-acoes">
              <button type="button" class="btn btn-sm btn-blue"
                      (click)="novaApresentacao()"
                      [disabled]="salvandoApresentacao">
                <i class="fe-plus mr-1"></i>Nova unidade de compra
              </button>
              <button type="button" class="btn btn-sm btn-outline-primary"
                      [hidden]="!apresentacoesGlobaisDisponiveis().length"
                      (click)="vinculeApresentacaoCadastrada()"
                      [disabled]="!!apresentacaoEditando || salvandoApresentacao">
                <i class="fas fa-link mr-1"></i>Vincular cadastrada
              </button>
            </span>
          </div>

          <div class="alert alert-danger" *ngIf="mensagemErroApresentacao">
            {{mensagemErroApresentacao}}
          </div>
          <div class="alert alert-success" *ngIf="mensagemSucessoApresentacao">
            {{mensagemSucessoApresentacao}}
          </div>

          <div class="text-center p-3" *ngIf="carregandoApresentacoes">
            <span class="spinner-border spinner-border-sm text-primary"></span>
            Carregando unidades de compra...
          </div>

          <div class="edicao-apresentacao mb-3" *ngIf="apresentacaoEditando">
            <div class="row align-items-end">
              <div class="form-group col-md-6" *ngIf="!apresentacaoEditando.id">
                <label>Unidade de compra</label>
                <kendo-dropdownlist name="apresentacaoGlobalInsumo"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="apresentacaoEditando.apresentacaoCompra"
                                    [data]="apresentacoesGlobaisDisponiveis()" [textField]="'descricao'"
                                    class="form-control" style="border: none;">
                </kendo-dropdownlist>
              </div>
              <div class="form-group col-md-6" *ngIf="apresentacaoEditando.id">
                <label>Unidade de compra</label>
                <div class="form-control bg-light">
                  {{apresentacaoEditando.apresentacaoCompra?.descricao}} —
                  {{apresentacaoEditando.apresentacaoCompra?.tipoEmbalagem?.nome}}
                </div>
              </div>
              <div class="form-group col-md-3">
                <div class="custom-control custom-checkbox">
                  <input id="apresentacaoPadrao" type="checkbox" class="custom-control-input"
                         [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="apresentacaoEditando.padrao">
                  <label for="apresentacaoPadrao" class="custom-control-label">Padrão</label>
                </div>
                <div class="custom-control custom-checkbox mt-2">
                  <input id="apresentacaoAtiva" type="checkbox" class="custom-control-input"
                         [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="apresentacaoEditando.ativa">
                  <label for="apresentacaoAtiva" class="custom-control-label">Ativa</label>
                </div>
              </div>
              <div class="form-group col-md-3" *ngIf="apresentacaoEditando.apresentacaoCompra">
                <span class="text-muted">Conversão</span><br>
                <b>1 → {{resultadoVisualApresentacao(apresentacaoEditando)}}</b>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-muted">
                A descrição, a embalagem e o fator são administrados na aba Unidades de compra.
              </span>
              <span>
                <button type="button" class="btn btn-light mr-1"
                        (click)="canceleEdicaoApresentacao()">Cancelar</button>
                <button type="button" class="btn btn-success" (click)="salveApresentacao()"
                        [disabled]="salvandoApresentacao || !apresentacaoValida()">
                  <i *ngIf="salvandoApresentacao" class="k-icon k-i-loading"></i>Salvar unidade de compra
                </button>
              </span>
            </div>
          </div>

          <div class="table-responsive" *ngIf="!carregandoApresentacoes && apresentacoesCompra.length">
            <table class="table table-sm table-hover mb-0">
              <thead>
                <tr>
                  <th>Descrição</th>
                  <th>Tipo</th>
                  <th>Conversão</th>
                  <th *ngIf="fornecimentoConfigurado">Produto na fábrica</th>
                  <th class="text-right">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let apresentacao of apresentacoesCompra">
                  <td>
                    {{apresentacao.apresentacaoCompra?.descricao}}
                    <span class="badge badge-primary ml-1" *ngIf="apresentacao.padrao">Padrão</span>
                  </td>
                  <td>{{apresentacao.apresentacaoCompra?.tipoEmbalagem?.nome}}</td>
                  <td>{{apresentacao.apresentacaoCompra?.descricao}} → {{resultadoVisualApresentacao(apresentacao)}}</td>
                  <td *ngIf="fornecimentoConfigurado">
                    <span class="badge" [ngClass]="classeCorrespondencia(apresentacao)"
                          kendoTooltip [title]="apresentacao.correspondencia?.motivo || ''">
                      {{rotuloCorrespondencia(apresentacao)}}
                    </span>
                    <small class="d-block text-muted"
                           *ngIf="apresentacao.correspondencia?.vinculo?.produto">
                      {{apresentacao.correspondencia.vinculo.produto.codigo || '-'}} —
                      {{apresentacao.correspondencia.vinculo.produto.nome}}
                    </small>
                    <small class="d-block text-muted"
                           *ngIf="!apresentacao.correspondencia?.vinculo?.produto && apresentacao.codigoFornecedor">
                      Código informado: {{apresentacao.codigoFornecedor}}
                    </small>
                  </td>
                  <td class="text-right">
                    <button type="button" class="btn btn-sm btn-outline-primary mr-1"
                            (click)="configureDePara(apresentacao)"
                            [disabled]="!apresentacao.ativa || !!apresentacaoEditando"
                            *ngIf="fornecimentoConfigurado"
                            kendoTooltip title="Configurar produto na fábrica">
                      <i class="fas fa-link"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-primary"
                            (click)="editeApresentacao(apresentacao)"
                            [disabled]="!!apresentacaoEditando">Editar</button>
                    <button type="button" class="btn btn-sm btn-outline-danger ml-1"
                            (click)="removaVinculoApresentacao(apresentacao)"
                            [disabled]="!!apresentacaoEditando || !!removendoVinculoApresentacaoId"
                            kendoTooltip title="Remover vínculo com o insumo">
                      <i class="fa fa-trash" *ngIf="removendoVinculoApresentacaoId !== apresentacao.id"></i>
                      <i class="k-icon k-i-loading" *ngIf="removendoVinculoApresentacaoId === apresentacao.id"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="alert alert-info"
               *ngIf="!carregandoApresentacoes && !apresentacoesCompra.length && !apresentacaoEditando">
            <h5 class="alert-heading">Este insumo ainda não possui uma unidade de compra</h5>
            <p class="mb-2">
              A unidade de compra representa a embalagem ou quantidade em que o insumo é recebido
              e converte automaticamente a entrada para a unidade-base controlada no estoque.
            </p>
            <ul class="mb-2 pl-3">
              <li>
                Água controlada em <b>unidades</b>: ao receber 2 fardos com 12, entram
                <b>24 unidades</b> no estoque.
              </li>
              <li>
                Farinha controlada em <b>kg</b>: ao receber 3 sacos de 5 kg, entram
                <b>15 kg</b> no estoque.
              </li>
            </ul>
            <span>
              Use <b>Nova unidade de compra</b> para cadastrar uma conversão ou
              <b>Vincular cadastrada</b> para reutilizar uma já existente.
            </span>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light waves-effect" data-dismiss="modal"
                  (click)="fecheModal(this.insumo)">Fechar</button>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [title]="'Composição'"  *ngIf="insumo.fichaTecnica"
                        [selected]="abaSelecionada === 2"   >

      <ng-template kendoTabContent>

        <form [ngClass]="{'needs-validation': !frmFicha.submitted, 'was-validated': frmFicha.submitted}"
              novalidate #frmFicha="ngForm" (ngSubmit)="onSalvarReceita()" >


          <div style="max-height: 600px">
            <div class="row">
              <div class="form-group  col-6">
                <label  >Rendimento</label>
                <kendo-numerictextbox id="rendimento" [min]="0"   [format]="obtenhaFormato()"
                                      class="form-control" name="rendimento" #rendimento=ngModel
                                      [(ngModel)]="insumo.receita.rendimento" required
                                      placeholder="rendimento em {{obtenhaDescricaoUnidade(insumo)}}">
                </kendo-numerictextbox>

                <div class="invalid-feedback">
                  <p *ngIf="rendimento.errors?.required">Obrigatório</p>
                  <p *ngIf="rendimento.errors?.minError">Informa valor maior que 0</p>
                </div>

                <div *ngIf="fichaTecnicaDeProdutoVenda()" class="text-muted font-11">
                    recomendado para ficha tecnica do tipo produto é <b>1 {{obtenhaDescricaoUnidade(insumo)}}</b>
                </div>
              </div>
            </div>

            <h4>
              Insumos
              <button class="btn btn-outline-blue btn-xs ml-2" (click)="novoIngrediente()">
                <b> <i class="fe-plus"></i> Adicionar</b> </button>
            </h4>

            <kendo-grid [data]="insumo.receita.ingredientes">
              <kendo-grid-column    [width]="30">
                <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
                  <span [class.removido]="dataItem.removido">         {{rowIndex + 1}}</span>

                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column   title="Ingrediente" [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <app-selecionar-insumo [exbirLabel]="false" [selectedItem]="dataItem" [indice]="rowIndex" [formClass]="''">

                  </app-selecionar-insumo>
                </ng-template>
                <ng-template kendoGridFooterTemplate *ngIf="controleCustoEstoqueAtivo">
                  <strong>Total</strong>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Custo médio" [width]="90" *ngIf="controleCustoEstoqueAtivo">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <strong *ngIf="custoMedioDoIngrediente(dataItem) !== null">
                    {{custoMedioDoIngrediente(dataItem) | currency:'BRL':'symbol':'1.2-6'}}
                  </strong>
                  <span class="text-warning" *ngIf="custoMedioDoIngrediente(dataItem) === null">
                    Desconhecido
                  </span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="quantidade" title="Quantidade" [width]="110">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <kendo-numerictextbox  [min]="0.0001"  placeholder="{{obtenhaDescricaoUnidade(dataItem.insumo)}}"
                                         class="k-input form-control" name="quantidade{{rowIndex}}"
                                          [format]="obtenhaFormatoDoInsumo(dataItem.insumo)"
                                         [(ngModel)]="dataItem.quantidade"  [disabled]="dataItem.removido"
                                         required>
                  </kendo-numerictextbox>

                  <div class="invalid-feedback">
                    <p *ngIf="dataItem.quantidade == null">Obrigatório</p>
                    <p *ngIf="dataItem.quantidade <= 0">Valor maior que 0</p>
                  </div>

                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Custo na composição" [width]="90" *ngIf="controleCustoEstoqueAtivo">
                <ng-template kendoGridHeaderTemplate>
                  Custo na <br>composição
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                  <strong *ngIf="custoDoIngredienteNaComposicao(dataItem) !== null">
                    {{custoDoIngredienteNaComposicao(dataItem) | currency:'BRL':'symbol':'1.2-6'}}
                  </strong>
                  <span class="text-warning" *ngIf="custoDoIngredienteNaComposicao(dataItem) === null">
                    Desconhecido
                  </span>
                </ng-template>
                <ng-template kendoGridFooterTemplate>
                  <strong *ngIf="custoTotalDaComposicao() !== null">
                    {{custoTotalDaComposicao() | currency:'BRL':'symbol':'1.2-6'}}
                  </strong>
                  <span class="text-warning" *ngIf="custoTotalDaComposicao() === null">
                    Desconhecido
                  </span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column  [width]="60">
                <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
                  <button kendoGridRemoveCommand kendoTooltip title="remover" (click)="removeIngrediente(rowIndex)" [hidden]="dataItem.removido"  >
                    <i class="fa fa-trash text-danger"></i>
                  </button>

                  <button class="btn btn-xs btn-warning" *ngIf="dataItem.removido"  (click)="dataItem.removido = null"
                          kendoTooltip title="desfazer remoção">
                    <i class="k-i-undo k-icon"></i>
                  </button>

                </ng-template>
              </kendo-grid-column>
            </kendo-grid>

          </div>

          <div class="modal-footer">
            <p *ngIf="mensagemSucesso" class="text-success ">
              <i class="mdi mdi-check-all mr-1"></i> {{mensagemSucesso}}
            </p>

            <p  *ngIf="mensagemErro" class="text-danger ">
              <i class="mdi mdi-check-all mr-1"></i> {{mensagemErro}}
            </p>

            <button type="submit" class="btn btn-primary waves-effect waves-light"
                    [disabled]="salvando"  >
              <i *ngIf="salvando" class="k-icon k-i-loading"></i>Salvar</button>
            <button type="button" class="btn btn-light waves-effect" data-dismiss="modal"
                    (click)="fecheModal(this.insumo)">Fechar</button>
          </div>

        </form>



      </ng-template>

    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [title]="'Vinculos com produtos' + (insumo.id ? '(' + insumo.totalVinculos + ')'  : '')"
                        [disabled]="!insumo.id" [selected]="abaSelecionada === 3">
      <ng-template kendoTabContent>
        <app-tela-associar-insumo [insumo]="insumo"></app-tela-associar-insumo>
      </ng-template>


    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [title]="'Movimentações'" [disabled]="!insumo.id" [selected]="abaSelecionada === 4">
      <ng-template kendoTabContent>

        <div *ngIf="!novaMovimentacao">
          <button  class="btn btn-blue mb-2" (click)="gerarMovimentacao()">
            <i class="fe-plus"></i> Gerar movimentaçao
          </button>

          <app-tela-historico-movimentacoes [insumo]="insumo" #telaMovimentacoes>

          </app-tela-historico-movimentacoes>
        </div>

        <div *ngIf="novaMovimentacao">
          <div class="resumo-movimentacao">
            <div class="resumo-movimentacao-item" *ngIf="insumo.estoque">
              <span class="resumo-movimentacao-icone estoque">
                <i class="fas fa-box"></i>
              </span>
              <span>
                <small>Estoque atual</small>
                <b>{{insumo.estoque.quantidade | number:'1.0-3'}} {{obtenhaDescricaoUnidade(insumo)}}</b>
              </span>
            </div>

            <div class="resumo-movimentacao-item" *ngIf="insumo.receita">
              <span class="resumo-movimentacao-icone rendimento">
                <i class="fas fa-balance-scale"></i>
              </span>
              <span>
                <small>Rendimento da composição</small>
                <b>{{insumo.receita.rendimento | number:'1.0-3'}} {{obtenhaDescricaoUnidade(insumo)}}</b>
              </span>
            </div>

            <div class="resumo-movimentacao-item"
                 *ngIf="controleCustoEstoqueAtivo && insumo.estoque?.custoMedio != null">
              <span class="resumo-movimentacao-icone custo">
                <i class="fas fa-dollar-sign"></i>
              </span>
              <span>
                <small>Custo médio atual</small>
                <b>{{insumo.estoque.custoMedio | currency:'BRL':'symbol':'1.2-6'}}</b>
              </span>
            </div>
          </div>

          <app-form-movimentacao-insumo [movimentacao]="novaMovimentacao"
                (onSalvou)="salvouMovimentacao($event)" (onCancelou)="cancelouMovimentacao()"></app-form-movimentacao-insumo>

        </div>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab id="Histórico" [title]="'Histórico'" *ngIf="insumo.id && usuarioLogado && usuarioLogado.admin">
      <ng-template kendoTabContent>
        <app-historico-insumo [insumo]="insumo"></app-historico-insumo>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>

</div>
